import { useState, useRef } from "react";
import InputKidsMulti from "../../helpers/InputKidsMulti";
import InputSearchKid from "../../helpers/InputSearchKid";
import KidInfo from "./KidInfo";


function Kid(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const [errTab, setErrTab] = useState([]);  //z info od serwera..

    const [fraza,setFraza] = useState("");


    const [selectedID, setSelectedId] = useState(-1);
 

    const valChangeListener = (filedName, val, correct, msg) => {

        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);     
      //  setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }  

    const goNextNew = () => {
        console.log("goNext");
      //  saveData();
    }


    const onKidsSelected = (tab) => {

        console.log("onKidsSelected",tab);
        //setRow( {...row, ["dzieci"]: tab  } );

        if(tab.length > 0)
        {
             setSelectedId( tab[0]["id"] );
        }else 
        {
             setSelectedId(-1);
        }

    }

    const kidSelected = (p_dziecko_id) => { 
        //setRow( {...row, ['p_dziecko_id']:p_dziecko_id  } );

        console.log("kidSelected", p_dziecko_id ); 
        setSelectedId(p_dziecko_id);
    }

    const onBack = () => {
        setSelectedId(-1);
    }



    if(refreshView != props.userData.refreshView)
        {
            setRefreshView( props.userData.refreshView);   
            setSelectedId(-1);
        }



   
    if(selectedID < 1)
    {
        return <div className="view_content">              
                <div className="big_search">
                    <InputKidsMulti   userData={props.userData}  mainView={props.mainView} onKidsSelected={onKidsSelected} max="1" info="" />  
                    lub szukaj po frazie
                    <InputSearchKid  mainView={props.mainView} userData={props.userData}   err={errTab} kidSelected={kidSelected} valChange={valChangeListener} goNext={goNextNew} name="fraza" placeholder={"Szukaj: np. Agata Nowak "} className=' w250 ' req='1' firstUp="1" />                   
                </div>                   
        </div>
    }



    return <div className="view_content">  
                  <KidInfo  userData={props.userData}  mainView={props.mainView} p_dziecko_id={selectedID} onBack={onBack} />    
    </div>

   
}


export default Kid;